"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToggleCameraButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const ui_react_1 = require("@streem/ui-react");
const room_session_1 = require("../../../../context/room_session");
const rxjs_1 = require("../../../../hooks/rxjs");
const toolbar_button_1 = require("./toolbar_button");
const use_local_video_controller_state_1 = require("../../../../hooks/use_local_video_controller_state");
function ToggleCameraButton() {
    const roomSession = (0, room_session_1.useRoomSession)();
    const theme = (0, ui_react_1.useTheme)();
    const [label, setLabel] = (0, react_1.useState)('');
    const [localVideoController] = (0, rxjs_1.useObservable)(roomSession.media.localVideoController);
    const [localVideoControllerState] = (0, use_local_video_controller_state_1.useLocalVideoControllerState)(roomSession.media.localVideoController);
    (0, react_1.useEffect)(() => {
        if (!localVideoControllerState || !localVideoControllerState.connected) {
            setLabel('Connecting...');
            return;
        }
        let msg = '';
        if (!localVideoControllerState.started) {
            msg = 'Looking for camera...';
        }
        if (localVideoControllerState.started && localVideoControllerState.enabled) {
            msg = 'Stop Camera';
        }
        if (localVideoControllerState.started && !localVideoControllerState.enabled) {
            msg = 'Start Camera';
        }
        setLabel(msg);
    }, [localVideoControllerState]);
    if (!localVideoController) {
        return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
    }
    return ((0, jsx_runtime_1.jsx)(toolbar_button_1.ToolbarButton, { "data-testid": label, label: label, disableButton: (localVideoControllerState === null || localVideoControllerState === void 0 ? void 0 : localVideoControllerState.connected) === false, fill: (localVideoControllerState === null || localVideoControllerState === void 0 ? void 0 : localVideoControllerState.enabled) ? theme.colors.azure : theme.colors.red50, hoverFill: (localVideoControllerState === null || localVideoControllerState === void 0 ? void 0 : localVideoControllerState.enabled)
            ? theme.colors.azureTransparent
            : theme.colors.red50Transparent, iconName: (localVideoControllerState === null || localVideoControllerState === void 0 ? void 0 : localVideoControllerState.enabled) ? 'CameraIcon' : 'CameraOffIcon', onClick: () => {
            if (localVideoController && localVideoControllerState) {
                localVideoController.setEnabled(!localVideoControllerState.enabled);
            }
        } }));
}
exports.ToggleCameraButton = ToggleCameraButton;
//# sourceMappingURL=toggle_camera_button.js.map